export const FILE_UPLOAD_URL = 'https://media.getzyk.com/uploadMediaFile/6'
export const BASE_API_URL = '//starbe.services-money91.com/base'
    // export const BASE_API_URL = 'http://13.233.236.54:5006/base'